import { NotificationManager } from 'react-notifications';

/**
 * Toast timeout (ms)
 */
const timeout = 20000;

/**
 * Pop up a success toast
 * @param {string} message
 * @param {number} timeout
 */
export function success (message, timeout = 2500) {
  NotificationManager.success(message, undefined, timeout);
}

/**
 * Pop up a info toast
 * @param {string} message
 */
export function info (message) {
  NotificationManager.info(message, undefined, timeout);
}

/**
 * Pop up a warning toast
 * @param {string} message
 * @param {number} timeout
 */
export function warning (message, timeout = 2500) {
  NotificationManager.warning(message, undefined, timeout);
}

/**
 * Pop up a error toast
 * @param {string} message
 */
export function error (message) {
  NotificationManager.error(message, undefined, timeout);
}
